import { atom } from "recoil";

export const deviceNameArrAtom = atom({
  key: "deviceNameArr",
  default: [],
});

export const deviceInfoArrAtom = atom({
  key: "deviceInfoArr",
  default: [],
});

export const deviceCheckedArrAtom = atom({
  key: "deviceCheckedArr",
  default: {},
});

export const deviceColorArrAtom = atom({
  key: "deviceColorArr",
  default: {},
});

export const deviceCntTimestampAtom = atom({
  key: "deviceCntTimestamp",
  default: 0,
});

export const deviceCenterAtom = atom({
  key: "deviceCenter",
  default: "",
});
